import { Button, Theme, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import logoLetter from "src/assets/logos/logo-letter.png";
import viper from "src/assets/images/viper.png";
import { usePool } from "@nftvillage/farms-sdk";
import { TOKEN_STAKING_POOL_IDS } from "src/config/config";
import { useTimer } from "src/hooks/useTimer";

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    width: "350px",
    padding: "20px",
    height: 250,
    position: "relative",
    top: 30,
    background: theme.palette.text.primary,
    [theme.breakpoints.down("md")]: {
      top: 0,
      width: "300px",
    },
  },
  logo: {
    width: 100,
    position: "absolute",
    transform: " matrix(-0.91, -0.41, -0.41, 0.91, 0, 0)",
    top: "80%",
    left: "-10%",
    [theme.breakpoints.down("md")]: {
      width: 100,
      top: "70%",
    },
  },
  viper: {
    width: 250,
    position: "absolute",
    top: "0%",
    left: "60%",
    [theme.breakpoints.down("md")]: {
      zIndex: -1,
      top: "-250%",
      left: "10%",
      opacity: 0.3,
      mixBlendMode: "luminosity",
    },
  },
}));

const Reward = () => {
  const classes = useStyles();
  const pool = usePool(TOKEN_STAKING_POOL_IDS[0]);
  const { timeLeft, timeFinished } = useTimer(pool?.details?.userInfo?.canHarvestAt!);

  const getRewardInUSD = () => {
    return pool?.details.rewardInfo[0].details?.price?.times(pool.rewards[0].rewards)?.toFormat(2);
  };

  return (
    <div className={classes.root}>
      <Typography variant="h4" fontFamily={"Oswald"} component={"div"} sx={{ color: "white" }}>
        Rewards
        <Typography variant="h3" fontFamily={"Oswald"}>
          {pool?.rewards[0].rewards ?? "0.00"}
        </Typography>
        <Typography fontFamily={"Oswald"} align="left" ml={6} sx={{ color: "white" }}>
          ${getRewardInUSD()}
        </Typography>
        <Typography fontFamily={"Oswald"} align="left" ml={6} sx={{ color: "white" }}>
          ANTZ
        </Typography>
      </Typography>

      <Button
        onClick={() => pool?.harvestInfo.harvest()}
        variant="contained"
        disableElevation
        sx={{ background: "black", width: "60%", mt: 3 }}
        disabled={!timeFinished}
      >
        {!timeFinished
          ? `${timeLeft.days}D : ${timeLeft.hours}H : ${timeLeft.minutes}M : ${timeLeft.seconds}S`
          : pool?.harvestInfo.pending
          ? "Pending..."
          : "Harvest"}
      </Button>
      <img src={viper} className={classes.viper} />
      <img src={logoLetter} className={classes.logo} />
    </div>
  );
};

export default Reward;
